import Lang from 'lang.js';
import * as FilePond from 'filepond';
import Sortable from 'sortablejs';

const default_locale = window.default_locale;
const fallback_locale = window.fallback_locale;
const messages = window.messages;

const trans = new Lang({
    messages,
    locale: default_locale,
    fallback: fallback_locale
});

export default () => ({
    contents: [],
    contentsGrouped: {},
    selected: {},
    files: [],
    times: [],
    preselected: null,
    mediaplan: {},
    content: "",
    audio_in_event: [],
    production_status: 0,
    production_check: false,
    production_date: null,
    production_note: null,
    currentGroup: 0,
    currentGroupStatus: null,
    event_type_check: false,
    event_type: 0,

    same_content: true,
    same_audio: true,

    audio_overwrite: true,
    content_overwrite: true,

    audio_before_event: [],
    audio_after_event: [],

    approval_note: null,
    approval_note_display: null,

    alertMessage: "",

    saveBtn: null,
    approveBtn: null,
    disapproveBtn: null,
    producedBtn: null,
    deleteBtn: null,

    not_full_group: false,
    multiple_groups: false,

    init() {
        if(document.querySelector('#saveBtn')) {
            this.saveBtn = Ladda.create(document.querySelector('#saveBtn'));
        }
        if(document.querySelector('#approveBtn')) {
            this.approveBtn = Ladda.create(document.querySelector('#approveBtn'));
        }
        if(document.querySelector('#disapproveBtn')) {
            this.disapproveBtn = Ladda.create(document.querySelector('#disapproveBtn'));
        }
        if(document.querySelector('#producedBtn')) {
            this.producedBtn = Ladda.create(document.querySelector('#producedBtn'));
        }
        if(document.querySelector('#deleteBtn')) {
            this.deleteBtn = Ladda.create(document.querySelector('#deleteBtn'));
        }

        $("#production_date").datepicker({
            format: "dd.mm.yyyy",
            language: window.default_locale,
            todayBtn: "linked"
        }).on('changeDate', (e) => {
            this.production_date = e.target.value;
        });

        this.$watch('preselected', (value) => {
            if(value) {
                this.selectGroup(value);
            }
        });

        this.$watch('mediaplan', (value) => {
            FilePond.create(document.getElementById("file_upload"), {
                server: {
                    url: window.location.origin + "/mediaplan/specialoperations/upload?temp_key=" + value.nutemp_key,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                },
                allowRemove: false,
                allowRevert: false,
                labelIdle: trans.get('Drag & Drop your files or') + ' <span class="filepond--label-action"> ' + trans.get('Browse') + ' </span>',
            }).on('processfile', (e, f) => {
                if(e) {
                    toastr.error(e, trans.get("Error"));
                    return;
                }

                axios.post(window.location.origin + "/mediaplan/specialoperations/" + this.mediaplan.web_mp_nu_id + "/content/attachfiles");

                let data = JSON.parse(f.serverId);
                this.files.push(data);
            });
        });

        this.$watch('production_check', (value) => {
            if(value) {
                var first_date = null;

                for(const key in this.selected) {
                    let item = this.selected[key];
                    if(item.dd < first_date || first_date == null) {
                        first_date = item.dd;
                    }
                }

                if(first_date != null && (this.production_date == null || this.production_date == "")) {
                    this.production_date = moment("01.01.1997", "DD.MM.YYYY").add(first_date - 1, 'days').format("DD.MM.YYYY");
                }
            }
        });

        Sortable.create(this.$refs.audio_in_event, {
            animation: 150,
            onEnd: (event) => {
                let newAudio = Alpine.raw(this.audio_in_event);
                const droppedAtItem = newAudio.splice(event.oldIndex, 1)[0]
                newAudio.splice(event.newIndex, 0, droppedAtItem)
                for(let i = 0; i < newAudio.length; i++) {
                    newAudio[i].rporadie1 = i + 1;
                }
                this.audio_in_event = newAudio;
            }
        });

        Sortable.create(this.$refs.audio_after_event, {
            animation: 150,
            onEnd: (event) => {
                let newAudio = Alpine.raw(this.audio_after_event);
                const droppedAtItem = newAudio.splice(event.oldIndex, 1)[0]
                newAudio.splice(event.newIndex, 0, droppedAtItem)
                for(let i = 0; i < newAudio.length; i++) {
                    newAudio[i].rporadie1 = i + 1;
                }
                this.audio_after_event = newAudio;
            }
        });

        Sortable.create(this.$refs.audio_before_event, {
            animation: 150,
            onEnd: (event) => {
                let newAudio = Alpine.raw(this.audio_before_event);
                const droppedAtItem = newAudio.splice(event.oldIndex, 1)[0]
                newAudio.splice(event.newIndex, 0, droppedAtItem)
                for(let i = 0; i < newAudio.length; i++) {
                    newAudio[i].rporadie1 = i + 1;
                }
                this.audio_before_event = newAudio;
            }
        });
    },

    tapHold(element, callback) {
        var startTime, endTime;
        var gbMove = false;
        var interval = null;

        element.addEventListener('touchstart',function(event) {
            startTime = new Date().getTime();
            gbMove = false;
            interval = setInterval(() => {
                if(gbMove) {
                    return;
                }

                endTime = new Date().getTime();
                if((endTime-startTime) > 800) {
                    clearInterval(interval);
                    callback(event);
                    return;
                }
            }, 100);
        },false);

        element.addEventListener('touchmove',function(event) {
            gbMove = true;
        },false);

        element.addEventListener('touchend',function(event) {
            clearInterval(interval);
        },false);
    },

    select(event) {
        let $el = $(event.currentTarget);
        let key = $el.attr("data-key");
        let plan = JSON.parse($el.attr("data-plan"));
        if($el.hasClass("bg-success")) {
            if(!(key in this.selected)) {
                if(event.ctrlKey) {
                    this.selected[key] = plan;
                    $el.toggleClass("selected");
                } else {
                    if($el.attr("data-group")) {
                        this.selectGroup($el.attr("data-group"));
                    } else {
                        for(const key2 in this.selected) {
                            let item = this.selected[key2];
                            if(item.group) {
                                this.deselect($("#stuff td[data-key='" + key2 + "']"), key2);
                            }
                        }
                        this.selected[key] = plan;
                        $el.toggleClass("selected");
                    }
                }
                this.compareContent();
            } else {
                this.deselect(event.currentTarget, key);
            }
        }
        this.clearSelection();
    },

    deselect(element, key) {
        if(key in this.selected) {
            delete this.selected[key];
            $(element).toggleClass("selected");
        }
    },

    clearSelection() {
        if(Object.keys(this.selected).length == 0) {
            this.content = "";
            this.alertMessage = "";
            this.audio_in_event = [];
            this.production_status = 0;
            this.production_check = false;
            this.production_date = null;
            this.production_note = null;
            this.audio_before_event = [];
            this.audio_after_event = [];
            this.event_type = 0;
            this.currentGroupStatus = null;
            this.approval_note_display = null;
            $("#content-tabs ul li a").removeClass("active");
            $("#content-tabs ul li:first-child a").addClass("active");
            $("#content-tabs .tab-pane").removeClass("active");
            $("#content-tabs .tab-pane:first-child").addClass("active");
            $("#stuff td").removeClass("selected");
        } else {
            this.multiple_groups = false;
            this.not_full_group = false;
            this.alertMessage = "";
            this.approval_note_display = null;
            let first_selected = this.selected[Object.keys(this.selected)[0]];
            if(first_selected) {
                if(!first_selected.group) {
                    this.currentGroupStatus = null;
                    if(Object.keys(this.contentsGrouped).length == 0) {
                        this.currentGroup = 1;
                    } else {
                        this.currentGroup = parseInt(Object.keys(this.contentsGrouped).slice(-1)) + 1;
                    }
                } else {
                    this.currentGroup = first_selected.group;
                }
                for(const key in this.selected) {
                    let item = this.selected[key];
                    if(item.group != first_selected.group) {
                        this.multiple_groups = true;
                    }
                }
                let contents = this.contents.filter(content => content.nuo_group == first_selected.group);

                if(Object.keys(this.selected).length < contents.length) {
                    this.not_full_group = true;
                    this.currentGroup = parseInt(Object.keys(this.contentsGrouped).slice(-1)) + 1;
                }

                if(this.multiple_groups) {
                    this.alertMessage = trans.get("Selected items are not in same group");
                    this.currentGroup = parseInt(Object.keys(this.contentsGrouped).slice(-1)) + 1;
                    this.currentGroupStatus = null;
                }

                if(this.not_full_group) {
                    this.alertMessage = trans.get("Selected items are part of the group and the whole group is not selected.") + "<strong style='cursor:pointer' x-on:click='selectWholeGroup()'> " + trans.get("Select whole group") + "</strong>";
                }

                if(first_selected.content) {
                    if(first_selected.content.nuo_confirm_note) {
                        this.approval_note = first_selected.content.nuo_confirm_note;
                        this.approval_note_display = first_selected.content.nuo_confirm_note;
                    }
                }
            }

            $("#content-tabs ul li a").removeClass("active");
            $("#content-tabs ul li:last-child a").addClass("active");
            $("#content-tabs .tab-pane").removeClass("active");
            $("#content-tabs .tab-pane:last-child").addClass("active");
        }
    },

    compareContent() {
        let first = this.selected[Object.keys(this.selected)[0]];
        let same_content = true;
        let same_audio = true;

        if(first) {
            if(first.content) {
                for(const key in this.selected) {
                    let content = this.selected[key].content;

                    if(content) {
                        if(content.nuo_obsah != first.content.nuo_obsah) {
                            same_content = false;
                        }

                        if(!_.isEqual(JSON.parse(content.nuo_audio), JSON.parse(first.content.nuo_audio))) {
                            same_audio = false;
                        }
                    } else {
                        same_content = false;
                    }
                }

                this.content = first.content.nuo_obsah;
                this.audio_in_event = _.cloneDeep(JSON.parse(first.content.nuo_audio));
                this.audio_after_event = _.cloneDeep(JSON.parse(first.content.nuo_audio_after));
                this.audio_before_event = _.cloneDeep(JSON.parse(first.content.nuo_audio_before));
                this.production_status = first.content.nuo_vyr_stav;
                this.production_check = (first.content.nuo_vyr_stav == 1 || first.content.nuo_vyr_stav == 2);
                this.production_date = first.content.nuo_vyr_termin ? moment(first.content.nuo_vyr_termin).format("DD.MM.YYYY") : "";
                this.production_note = first.content.nuo_vyr_popis;
                if(first.content.nuo_utyp != 0) {
                    this.event_type_check = true;
                    this.event_type = first.content.nuo_utyp;
                } else {
                    this.event_type_check = false;
                    this.event_type = 0;
                }
                this.currentGroupStatus = first.content.nuo_stav;

                $("#production_date").datepicker('update', moment(first.content.nuo_vyr_termin).format("DD.MM.YYYY"));

                if(first.content.nuo_vyr_maillist) {
                    let mails = JSON.parse(first.content.nuo_vyr_maillist);
                    $("#production_emails").val(mails).trigger("change");
                } else {
                    var mails = [];
                    Object.values($("#production_emails").find("option")).forEach(option => {
                        mails.push(option.value);
                    });

                    $("#production_emails").val(mails).trigger("change");
                }

            } else {
                this.production_status = 0;
                this.production_check = false;
                this.production_date = null;
                this.production_note = null;

                this.event_type_check = false;

                for(const key in this.selected) {
                    if(this.selected[key].obsah != first.obsah) {
                        same_content = false;
                    }

                    if(!_.isEqual(this.selected[key].rds, first.rds)) {
                        same_audio = false;
                    }
                }

                this.content = first.obsah;
                this.audio_in_event = _.cloneDeep(first.rds);

                var mails = [];
                Object.values($("#production_emails").find("option")).forEach(option => {
                    mails.push(option.value);
                });

                $("#production_emails").val(mails).trigger("change");
            }
        }

        this.same_content = same_content;
        this.same_audio = same_audio;
    },

    addAudio(list) {
        list.push({
            rdsudalost1: '',
            editing: true,
            rporadie1: list.length + 1
        });
    },

    removeAudio(list, audio) {
        list.splice(list.indexOf(audio), 1);
    },

    saveContent() {
        this.saveBtn.start();
        var locked = false;

        for(const key in this.selected) {
            let item = this.selected[key];
            if(item.pzamknuty > 0) {
                locked = true;
            }
        }

        if(locked) {
            toastr.error(trans.get('One or more events are locked'), trans.get('Error'));
            this.saveBtn.stop();
            return;
        }

        if(this.multiple_groups) {
            swal.fire({
                title: trans.get("Selected items are not in same group"),
                text: trans.get("Items from different groups with contnent will be overrided and saved as new group. Do you want to continue?"),
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: trans.get("Cancel"),
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-outline-danger',
                buttonsStyling: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: trans.get("Continue"),
            }).then((result) => {
                if(result.isConfirmed) {
                    this.postData();
                } else {
                    this.saveBtn.stop();
                }
            });
        } else {
            this.postData();
        }

    },

    postData() {
        axios.post(window.location.origin + "/mediaplan/specialoperations/" + this.mediaplan.web_mp_nu_id + "/content", {
            selected: this.selected,
            content: this.content,
            content_overwrite: this.content_overwrite,
            audio_in_event: this.audio_in_event,
            audio_overwrite: this.audio_overwrite,
            audio_before_event: this.audio_before_event,
            audio_after_event: this.audio_after_event,
            same_content: this.same_content,
            same_audio: this.same_audio,
            production_check: this.production_check,
            production_date: this.production_date,
            production_note: this.production_note,
            production_emails: $("#production_emails").val(),
            currentGroup: this.currentGroup,
            event_type_check: this.event_type_check,
            event_type: this.event_type,
        }).then(response => {
            toastr.success(response.data.message, trans.get('Success'));
            this.saveBtn.stop();
            Livewire.emit('contentSaved', Object.keys(this.selected));
            setTimeout(() => {
                this.getContentData();
            }, 1000);
        }).catch(error => {
            if (error.response && error.response.data.message) {
                toastr.error(error.response.data.message, trans.get("Error"));
            } else {
                toastr.error(error.response.data, trans.get("Error"));
            }
            this.saveBtn.stop();
        });
    },

    deleteContent() {
        this.deleteBtn.start();
        var beforeToday = false;
        var locked = false;
        var actualDD = moment().diff(moment('1997/01/01', 'YYYY/MM/DD'), 'days');

        for(const key in this.selected) {
            let item = this.selected[key];
            if(item.dd <= actualDD) {
                beforeToday = true;
            }

            if(item.pzamknuty > 0) {
                locked = true;
            }
        }

        if(beforeToday) {
            toastr.error(trans.get('Content dated earlier than today cannot be deleted'), trans.get('Error'));
            this.deleteBtn.stop();
            return;
        }

        if(locked) {
            toastr.error(trans.get('One or more events are locked'), trans.get('Error'));
            this.deleteBtn.stop();
            return;
        }

        swal.fire({
            title: trans.get("Do you really want to unschedule selected items?"),
            text: trans.get("The set contents and sounds will be returned to their original values. The selected items will be removed from the mediaplan and set for sale again"),
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: trans.get("Cancel"),
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-outline-danger',
            buttonsStyling: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: trans.get("Continue"),
        }).then((result) => {
            if(result.isConfirmed) {
                this.deleteData();
            } else {
                this.deleteBtn.stop();
            }
        });
    },

    deleteData() {
        axios.post(window.location.origin + "/mediaplan/specialoperations/" + this.mediaplan.web_mp_nu_id + "/content/delete", {
            selected: _.cloneDeep(this.selected),
        }).then(response => {
            toastr.success(response.data.message, trans.get('Success'));
            this.deleteBtn.stop();
            this.selected = {};
            Livewire.emit('contentSaved', Object.keys(this.selected));
            setTimeout(() => {
                this.getContentData();
            }, 1000);
        }).catch(error => {
            if (error.response && error.response.data.message) {
                toastr.error(error.response.data.message, trans.get("Error"));
            } else {
                toastr.error(error.response.data, trans.get("Error"));
            }
            this.deleteBtn.stop();
        });
    },

    getContentData() {
        let selected = Object.values(this.selected).map(item => item.idPlan).join(",");
        axios.get( window.location.origin + "/mediaplan/specialoperations/" + this.mediaplan.web_mp_nu_id + "/content/data?selected=" + selected)
        .then(response => {
            this.selected = response.data.selected.length == 0 ? {} : response.data.selected;
            this.contents = response.data.contents;
            this.contentsGrouped = response.data.contentsGrouped;
            this.compareContent();
            this.clearSelection();
        });
    },

    approveGroup() {
        this.approveBtn.start();
        var group = this.currentGroup;
        swal.fire({
            title: trans.get("Group approval") + " " + group,
            text: trans.get("The group will be sent to assess approval and then included in the broadcast."),
            type: 'warning',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off',
                placeholder: trans.get('Note')
            },
            showCancelButton: true,
            cancelButtonText: trans.get("Cancel"),
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-outline-danger',
            buttonsStyling: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: trans.get("Continue"),
            preConfirm: (note) => {
                this.approval_note = note;
                return true;
            },
        }).then((result) => {
            if(result.isConfirmed) {
                axios.post(window.location.origin + "/mediaplan/specialoperations/" + this.mediaplan.web_mp_nu_id + "/content/approve", {
                    group: group,
                    note: this.approval_note,
                    production_check: this.production_check,
                    production_emails: $("#production_emails").val(),
                    currentGroup: this.currentGroup,
                }).then(response => {

                    var interval = setInterval(() => {
                        axios.get(window.location.origin + "/mediaplan/specialoperations/" + this.mediaplan.web_mp_nu_id + "/content/checkstatus?group=" + group)
                        .then(response => {
                            if(response.data.status == 2) {
                                toastr.success(trans.get('Content was successfully approved'), trans.get('Success'));
                                Livewire.emit('contentSaved', Object.keys(this.selected));
                                this.getContentData();
                                clearInterval(interval);
                                this.approveBtn.stop();
                            }
                        });
                    }, 1000);

                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        toastr.error(error.response.data.message, trans.get("Error"));
                    } else {
                        toastr.error(error.response.data, trans.get("Error"));
                    }
                    this.approveBtn.stop();
                });
            } else {
                this.approveBtn.stop();
            }
        });
    },

    disapproveGroup() {
        this.disapproveBtn.start();
        var group = this.currentGroup;
        swal.fire({
            title: trans.get("Disapprove group") + " " + group,
            text: trans.get("Group will be labeled as disapproved and will expect additional adjustments."),
            type: 'warning',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off',
                placeholder: trans.get('Note')
            },
            showCancelButton: true,
            cancelButtonText: trans.get("Cancel"),
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-outline-danger',
            buttonsStyling: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: trans.get("Continue"),
            preConfirm: (note) => {
                this.approval_note = note;
                return true;
            },
        }).then((result) => {
            if(result.isConfirmed) {
                axios.post(window.location.origin + "/mediaplan/specialoperations/" + this.mediaplan.web_mp_nu_id + "/content/disapprove", {
                    group: group,
                    note: this.approval_note
                }).then(response => {
                    toastr.success(response.data.message, trans.get('Success'));
                    Livewire.emit('contentSaved', Object.keys(this.selected));
                    this.getContentData();
                    this.disapproveBtn.stop();
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        toastr.error(error.response.data.message, trans.get("Error"));
                    } else {
                        toastr.error(error.response.data, trans.get("Error"));
                    }
                    this.disapproveBtn.stop();
                });
            } else {
                this.disapproveBtn.stop();
            }
        });
    },

    approveProduction() {
        this.producedBtn.start();
        var group = this.currentGroup;
        swal.fire({
            title: trans.get("Set production as completed for group:") + " " + group,
            text: trans.get("Production of group will be labeled as completed."),
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: trans.get("Cancel"),
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-outline-danger',
            buttonsStyling: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: trans.get("Continue"),
        }).then((result) => {
            if(result.isConfirmed) {
                axios.post(window.location.origin + "/mediaplan/specialoperations/" + this.mediaplan.web_mp_nu_id + "/content/approveproduction", {
                    group: group
                }).then(response => {
                    toastr.success(response.data.message, trans.get('Success'));
                    Livewire.emit('contentSaved', Object.keys(this.selected));
                    this.getContentData();
                    this.production_status = 2;
                    this.producedBtn.stop();
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        toastr.error(error.response.data.message, trans.get("Error"));
                    } else {
                        toastr.error(error.response.data, trans.get("Error"));
                    }
                    this.producedBtn.stop();
                });
            } else {
                this.producedBtn.stop();
            }
        });
    },

    deleteFile(id) {
        axios.delete(window.location.origin + "/mediaplan/specialoperations/upload", {
            data: {
                id: id
            }
        }).then(response => {
            let file = this.files.find(file => file.id === id);
            this.files.splice(this.files.indexOf(file), 1);
        }).catch(error => {
            if (error.response) {
                toastr.error(error.response.data.message, trans.get("Error"));
            }
        });
    },

    generateSpot(audio) {
        axios.get(window.location.origin + "/spot/generate?channel=" + this.mediaplan.nuokruh + "&specialoperations=true")
            .then(response => {
                audio.rdsudalost1 = response.data;
            });
    },

    openSelectModal() {
        this.times = [];
        var that = this;
        $("#stuff td.zone").each(function(key, el) {
            that.times.push(el.innerText);
        });

        $("#selectModal").modal('show')
    },

    selectPlan() {
        let mo = $("[name=day_mo]").is(":checked");
        let tu = $("[name=day_tu]").is(":checked");
        let we = $("[name=day_we]").is(":checked");
        let th = $("[name=day_th]").is(":checked");
        let fr = $("[name=day_fr]").is(":checked");
        let sa = $("[name=day_sa]").is(":checked");
        let su = $("[name=day_su]").is(":checked");
        let days = [mo ? 1 : '', tu ? 2 : '', we ? 3 : '', th ? 4 : '', fr ? 5 : '', sa ? 6 : '', su ? 7 : ''];

        var times = [];
        $("input[name='time[]']").each(function(key, el) {
            if($(el).is(":checked")) {
                times.push($(el).val());
            }
        });

        let daterange = $("#daterange").val();

        let original = $("[name=leave_original]").is(":checked");
        let only_without_content = $("[name=only_without_content]").is(":checked");

        axios.post(window.location.origin + "/mediaplan/specialoperations/" + this.mediaplan.web_mp_nu_id + "/content/selectplan", {
            days: days,
            daterange: daterange,
            times: times,
        }).then(response => {
            if(!original) {
                this.clearSelected();
            }

            Object.keys(response.data.selected).forEach(key => {
                if(!(key in this.selected)) {
                    let $el = $("#stuff td[data-key='" + key + "']");

                    if((only_without_content && typeof $el.attr("data-group") === 'undefined') || !only_without_content) {
                        let plan = JSON.parse($el.attr("data-plan"));
                        this.selected[key] = plan;
                        $el.toggleClass("selected");
                    }
                }
            });

            this.compareContent();
            this.clearSelection();

            $("#selectModal").modal("hide");
        });
    },

    clearSelected() {
        this.selected = {};
        this.clearSelection();
    },

    selectDay(event) {
        let $rows = $("#stuff tr");
        let that = this;
        $rows.each(function() {
            let $el = $(this).find('td:nth-child(' + (event.cellIndex + 1) + ')');
            if($el.hasClass("bg-success")) {
                let key = $el.attr("data-key");
                let plan = JSON.parse($el.attr("data-plan"));

                if(!(key in that.selected)) {
                    that.selected[key] = plan;
                    $el.toggleClass("selected");
                    that.compareContent();
                } else {
                    delete that.selected[key];
                    $el.toggleClass("selected");
                    that.compareContent();
                }
            }
        });

        this.clearSelection();
    },

    selectWholeGroup() {
        let group = this.selected[Object.keys(this.selected)[0]].group;
        this.selectGroup(group);
    },

    selectGroup(group) {
        var that = this;
        this.currentGroup = group;
        this.selected = {};
        this.clearSelection();

        $("#groupsTable tbody tr").removeClass('bg-secondary');
        $("#groupsTable tbody tr[data-group=" + group + "]").addClass('bg-secondary');

        let $els = $("#stuff td[data-group='" + group + "']");
        $els.each(function() {
            let $el = $(this);
            let key = $el.attr("data-key");
            let plan = JSON.parse($el.attr("data-plan"));
            if($el.hasClass("bg-success")) {
                if(!(key in that.selected)) {
                    that.selected[key] = plan;
                    $el.toggleClass("selected");
                    that.compareContent();
                }
            }
        });

        this.clearSelection();
    },

    selectAll() {
        var that = this;
        $("#stuff td.bg-success").each(function() {
            let $el = $(this);
            let key = $el.attr("data-key");
            let plan = JSON.parse($el.attr("data-plan"));
            if(!(key in that.selected)) {
                that.selected[key] = plan;
                $el.toggleClass("selected");
            }
        });

        this.compareContent();
        this.clearSelection();
    },
});
